import type { Namespace } from './generated/i18n-meta'

export const namespaceGroups = {
  core: [
    'common',
    'feedback',
    'home',
    'leads',
    'property',
    'interest',
    'contactRequest',
    'user',
    'traits',
    'contacts',
  ] as const,
  authenticated: ['feed', 'pro', 'notes', 'sourceViewer', 'events'] as const,
  admin: ['admin'] as const,
} as const

export type NamespaceGroup = keyof typeof namespaceGroups

export const routeNamespaces: Record<string, readonly NamespaceGroup[]> = {
  '(front)': ['core'],
  '(authenticated)': ['core', 'authenticated'],
  '(authenticated)/admin': ['core', 'authenticated', 'admin'],
}

export function getNamespacesForRoute(routeGroup: string): Namespace[] {
  const groups = routeNamespaces[routeGroup] ?? ['core']
  const namespaces: Namespace[] = []

  for (const group of groups) {
    const groupNamespaces = namespaceGroups[group]

    for (const namespace of groupNamespaces) {
      if (!namespaces.includes(namespace)) {
        namespaces.push(namespace)
      }
    }
  }

  return namespaces
}

export function getCoreNamespaces(): Namespace[] {
  return [...namespaceGroups.core]
}
